import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { query } from '../graphql'

export const useCareerPresetQuery = (career_preset_id) => {
  return useQuery({
    queryKey: QUERY_KEYS.careerPreset(career_preset_id),
    queryFn: () => {
      return query({
        query: 'publicSqlQuery',
        variables: {
          action: 'query-career-preset',
          input: JSON.stringify({ career_preset_id })
        }
      })
    },
    select: (response) => {
      console.log('useCareerPresetQuery response:', response)
      const result = JSON.parse(response.Items)[0]
      result.name = JSON.parse(result.name)

      return result
    },
    enabled: !!career_preset_id
  })
}
